module.exports = __webpack_public_path__ + "static/media/aiva_email_image.724a969f.png";